<template>
  <div>
    <el-header>
          <el-form :model="formData" label-width="10px">
            <el-row>
              <el-form-item>
                <el-date-picker v-model="formData.day"  @change="renderAllEcharts" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month"
                                placeholder="选择月份" :clearable="false"/>
              </el-form-item>
            </el-row>
          </el-form>
        </el-header>
    <div>
          <div class="divSize" v-loading="finishedProductStorageAreaOutputLoading" element-loading-text="数据加载中"
               style="width: 100%;height: 300px;" id="finishedProductStorageAreaOutput"/>
        </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "MfgFinishedProductStorage",
  components: {},
  data() {
    return {
      formData: {
        day: this.getDateFormat(),
      },
      finishedProductStorageAreaOutput: {
        tooltip: {
          trigger: 'axis',
          type: 'shadow',
          axisPointer: {
          }
        },
        legend: {
          type: 'scroll',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              interval: 0
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'面积(㎡)',
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
        ],
        series: []
      },
      finishedProductStorageAreaOutputLoading: false,
    }
  }, methods: {
    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id, option) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },
    renderAllEcharts(){
      //计划实绩图表
      this.getFinishedProductStorageData()
    },

    //计划实绩图表
    async getFinishedProductStorageData() {
      this.finishedProductStorageAreaOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/finishedProductStorage/getFinishedProductStorageData', this.formData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.finishedProductStorageAreaOutput.xAxis[0].data = res.data.xAxis
        this.finishedProductStorageAreaOutput.series = res.data.finishedProductStorageList
        this.finishedProductStorageAreaOutput.legend.data = res.data.finishedProductStorageList
        let array = res.data.finishedProductStorageList
        let total = []
        for (let key in array) {
          array[key].data.forEach((value, index) => {
            if (value >= 0) {
              if (this.isBlank(total[index])) {
                total[index] = 0
              }
              total[index] += Math.ceil(value)
            }
          })
        }

        this.finishedProductStorageAreaOutput.yAxis[0].max = Math.ceil(Math.max(...total)/10)*10
        this.finishedProductStorageAreaOutput.yAxis[0].interval = Math.round(this.finishedProductStorageAreaOutput.yAxis[0].max*2/10*10)/10

      }
      this.renderEcharts('finishedProductStorageAreaOutput', this.finishedProductStorageAreaOutput)
      this.finishedProductStorageAreaOutputLoading = false
    },
    isBlank(val){
      if(val == null || val === ""){
        return true;
      }
    },

  },
  mounted() {
    //计划实绩图表
    this.getFinishedProductStorageData()
  },
  created() {

  }
}
</script>

<style scoped>
.padding {
  padding: 5px;
}

.pageStyle {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0
}

.el-table :deep(.cell) {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 0 12px;
  text-align: center;
}

.el-table :deep(.cell){
  padding: 0px;
}
.el-table :deep(.el-table__cell) {
  padding: 1px;
}
</style>